import { ajax as request } from '@blade/common';
/**
 * @description: 获取列表
 * @param {type}
 * @return {type}
 */
export const checkMsg = () => request({
    url: '/api/push-management/api/v1/message/check',
    method: 'GET',
});
export const clearMsg = () => request({
    url: '/api/push-management/api/v1/message/clear',
    method: 'POST',
});
